<template>
  <div>
    <div v-if="sortedOpenHouses.length" class="row">
      <div class="col">
        <h5>Next</h5>
        <div class="calendar text-center">
          <p class="no-margin">{{ calendarHeader }}</p>
          <p class="calendar-date no-margin">{{ new Date(firstOpenHouse.start_date).getUTCDate() }}</p>
          <p class="mb-1">{{ months[new Date(firstOpenHouse.start_date).getUTCMonth()] }}</p>
          <div class="calendar-bottom">{{ formatTimeRange(firstOpenHouse) }}</div>
        </div>
        <p v-if="!learnMore" v-on:click="showNextOpenHouseComment" class="link-text">Learn More</p>
        <div id="next-open-house-comment" style="display: none;"><span class="text-bold">Comments: </span>{{ firstOpenHouse.description }}</div>
        <p v-if="learnMore" v-on:click="showNextOpenHouseComment" class="link-text mb-1">Show Less</p>
        <!-- TODO: Build this functionality <button class="btn btn-primary">Add to Calendar</button>-->
      </div>
      <div v-if="extraOpenHouses.length" class="col">
        <h5>More</h5>
        <div v-for="openHouse in housesToDisplay" v-bind:key="openHouse.id">
          <i class="fa fa-calendar-alt icon-space"></i>{{ formatDate(openHouse) }}: {{ formatTimeRange(openHouse) }} <i v-on:click="showDescription(openHouse.uid)" class="fa fa-info-circle"></i>
          <div v-bind:id="openHouse.uid" style="display: none;"><span class="text-bold">Comments: </span>{{ openHouse.description }}</div>
        </div>
        <p v-if="extraOpenHouses.length >= numberOpenHousesToDisplay" v-on:click="loadMoreOpenHouses" class="link-text">See More</p>
        <button class="btn btn-primary full-width" v-on:click="showScheduleShowingModal">Request Private Showing</button>
      </div>
    </div>
    <div v-else class="row">
      <div class="col text-center">
        <p>No Open Houses Scheduled</p>
        <button class="btn btn-primary private-showing-button" v-on:click="showScheduleShowingModal">Request Private Showing</button>
      </div>
    </div>
    <schedule-showing-modal ref="scheduleShowingModal"></schedule-showing-modal>
  </div>
</template>

<script>
import ScheduleShowingModal from '../rightSide/ScheduleShowingModal.vue'

export default {
  components: {
    ScheduleShowingModal
  },
  data () {
    return {
      daysOfTheWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      learnMore: false,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      numberOpenHousesToDisplay: 3
    }
  },
  props: {
    openHouses: Array
  },
  methods: {
    showNextOpenHouseComment () {
      this.learnMore = !this.learnMore
      let comment = document.getElementById('next-open-house-comment')
      if (comment.style.display === 'none') {
        comment.style.display = 'block'
      } else {
        comment.style.display = 'none'
      }
    },
    showDescription (id) {
      let comment = document.getElementById(id)
      if (comment.style.display === 'none') {
        comment.style.display = 'block'
      } else {
        comment.style.display = 'none'
      }
    },
    loadMoreOpenHouses () {
      this.numberOpenHousesToDisplay += 3
    },
    formatTimeRange (openHouse) {
      let startTimeDate = new Date(openHouse.start_date)
      let startTimePeriod = startTimeDate.getUTCHours() > 12 ? 'pm' : 'am'
      let startTime = startTimeDate.getUTCHours() > 12 ? startTimeDate.getUTCHours() - 12 : startTimeDate.getUTCHours()

      let endTimeDate = new Date(openHouse.end_date)
      let endTimePeriod = endTimeDate.getUTCHours() > 12 ? 'pm' : 'am'
      let endTime = endTimeDate.getUTCHours() > 12 ? endTimeDate.getUTCHours() - 12 : endTimeDate.getUTCHours()
      return startTime.toString() + startTimePeriod + ' - ' + endTime.toString() + endTimePeriod
    },
    formatDate (openHouse) {
      let startTimeDate = new Date(openHouse.start_date)
      return this.daysOfTheWeek[startTimeDate.getUTCDay()] + ', ' + this.months[startTimeDate.getUTCMonth()] + ' ' + startTimeDate.getUTCDate()
    },
    showScheduleShowingModal () {
      this.$refs.scheduleShowingModal.showScheduleModal()
    }
  },
  computed: {
    housesToDisplay () {
      return this.extraOpenHouses.slice(0, this.numberOpenHousesToDisplay)
    },
    sortedOpenHouses () {
      if (!this.openHouses) return []
      return this.openHouses.slice().sort((a, b) => (b.start_date < a.start_date) ? 1 : -1)
    },
    extraOpenHouses () {
      return this.sortedOpenHouses.slice(1)
    },
    calendarHeader () {
      if (!this.sortedOpenHouses.length) return ''
      let today = new Date()
      let tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      let date = new Date(this.firstOpenHouse.start_date)
      if (today.getFullYear() === date.getUTCFullYear() &&
          today.getMonth() === date.getUTCMonth() &&
          today.getDate() === date.getUTCDate()
      ) {
        return 'Today'
      } else if (tomorrow.getFullYear() === date.getUTCFullYear() &&
          tomorrow.getMonth() === date.getUTCMonth() &&
          tomorrow.getDate() === date.getUTCDate()
      ) {
        return 'Tomorrow'
      } else {
        return this.daysOfTheWeek[date.getUTCDay()]
      }
    },
    firstOpenHouse () {
      if (!this.sortedOpenHouses.length) return null
      return this.sortedOpenHouses[0]
    }
  }
}
</script>

<style scoped>
.btn {
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 50% !important;
}

.calendar {
  border-style: solid;
  border-width: thin;
  width: 35%;
}

.calendar-bottom {
  background-color: red;
  color: white;
  border-top: solid;
  border-width: thin;
}

.calendar-date {
  font-size: 2.5rem;
}

.fa-info-circle {
  cursor: pointer;
}

.full-width {
  width: 100% !important;
}

.header {
  font-size: 1.5rem;
  font-weight: bold;
}

.icon-space {
  margin-right: 0.5rem;
}

.link-text {
  color: #2871d1 !important;
  cursor: pointer;
  margin-top: 1rem;
  margin-bottom: 0rem;
}

.no-margin {
  margin: 0;
}

.private-showing-button {
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .private-showing-button {
    max-width: 30%;
  }
}

.text-bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/OpenHouses.vue